import React, { memo } from "react";
import { Global, css } from "@emotion/core";

import CeraRegularWOFF from "./assets/fonts/cerapro-regular-webfont.woff";
import CeraRegularWOFF2 from "./assets/fonts/cerapro-regular-webfont.woff2";

import CeraMediumWOFF from "./assets/fonts/cerapro-medium-webfont.woff";
import CeraMediumWOFF2 from "./assets/fonts/cerapro-medium-webfont.woff2";

import CeraProBoldWOFF from "./assets/fonts/cera_pro_bold-webfont.woff";
import CeraProBoldWOFF2 from "./assets/fonts/cera_pro_bold-webfont.woff2";

const fontStyles = css`
    @font-face {
        font-family: "Cera";
        src: url("${CeraRegularWOFF2}") format("woff2"),
            url("${CeraRegularWOFF}") format("woff");
        font-weight: 400;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Cera";
        src: url("${CeraMediumWOFF2}") format("woff2"),
            url("${CeraMediumWOFF}") format("woff");
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }


    @font-face {
        font-family: "Cera";
        src: url("${CeraProBoldWOFF2}") format("woff2"),
            url("${CeraProBoldWOFF}") format("woff");
        font-weight: 700;
        font-style: normal;
        font-display: swap;
    }
`;

function Fonts() {
    return <Global styles={fontStyles} />;
}

export default memo(Fonts);
